




















































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import { maskMoney, timeout, timeoutDefault } from '@/utils/common'
import { RequestMessage, IRequestMessage } from '@/types/_'
import moment from 'moment'
import HistoricoSituacaoStore from '@/components/HistoricoSituacao/Store/HistoricoSituacaoStore'
import { displayColorByStatusGeracaoRepasse } from '@/utils/common'
import { formatHoras } from '@/utils/dataHora'

@Component
export default class ComponentModalItensDoRepasse extends Vue {
  getRequestMessage: IRequestMessage = new RequestMessage()
  loadAlterarPontuacaoProfissional: boolean = false
  loadAlterarPrestador: boolean = false
  loadAlterarFuncao: boolean = false
  loadModalAlterarFuncao: boolean = false
  modalAlterarFuncao: boolean = false
  sel: any[] = []
  selectedPrestadorFromValidacao: string = ''
  selectedProfissionalFromValidacao: string = ''

  get modalItensDoRepasse() { return this.getFinanceiroStore.modal.itensDoRepasse }
  set modalItensDoRepasse(value: boolean) { this.getFinanceiroStore.setModal({ name: 'itensDoRepasse', value }) }

  loadHistorico: string = ''
  get loadingHistorico() { return this.loadHistorico }
  set loadingHistorico(value: string) { this.loadHistorico = value }

  confirmarExclusao(id: any) {
    const ids = [id]
    this.getFinanceiroStore.setMotivoExclusaoItemRepasseId(ids)
    this.getFinanceiroStore.setModal({ name: 'excluirItemRepasse', value: true })
  }

  confirmarExclusaoEmLote(ids: any) {
    this.getFinanceiroStore.setMotivoExclusaoItemRepasseId(ids)
    this.getFinanceiroStore.setModal({ name: 'excluirItemRepasse', value: true })
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get getPagina() {
    return this.getFinanceiroStore.pagina
  }

  set getPagina(value: number) {
    this.getFinanceiroStore.setPagina(value)
  }

  get statusGeracaoDeRepasse() {
    return this.getFinanceiroStore.statusGeracaoDeRepasse
  }

  get backofficeFinanceiroGeracaoRepasseItensHeaders() {
    return this.getFinanceiroStore.backofficeFinanceiroGeracaoRepasseItensHeaders
  }

  get geracaoDeRepassesItemsPrestador() {
    return this.getFinanceiroStore.geracaoDeRepassesItemsPrestador
  }

  get acoesGeracaoRepasse() {
    return this.getFinanceiroStore.acoesItensDoRepasse
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get selected() { return this.sel }
  set selected(value: any) { this.sel = value }

  get loadingAlterarPontuacaoProfissional() {
    return this.loadAlterarPontuacaoProfissional
  }

  set loadingAlterarPontuacaoProfissional(value: boolean) {
    this.loadAlterarPontuacaoProfissional = value
  }

  get loadingAlterarPrestador() {
    return this.loadAlterarPrestador
  }

  set loadingAlterarPrestador(value: boolean) {
    this.loadAlterarPrestador = value
  }

  get loadingModalAlterarFuncao() {
    return this.loadModalAlterarFuncao
  }

  set loadingModalAlterarFuncao(value: boolean) {
    this.loadModalAlterarFuncao = value
  }

  get loadingAlterarFuncao() {
    return this.loadAlterarFuncao
  }

  set loadingAlterarFuncao(value: boolean) {
    this.loadAlterarFuncao = value
  }

  get showModalAlterarFuncao() {
    return this.modalAlterarFuncao
  }

  set showModalAlterarFuncao(value: boolean) {
    this.modalAlterarFuncao = value
  }

  get getTotal() {
    return this.getFinanceiroStore.totalItensPrestador || 0
  }

  get repasseLength() {
    return Math.ceil(this.getTotal / this.getFinanceiroStore.qtdPorPagina)
  }

  get funcao() {
    return this.getFinanceiroStore.funcoes
  }

  set funcao(value: any) {
    this.getFinanceiroStore.setFuncoes(value.key)
  }

  get apenasDivergentes() {
    return this.getFinanceiroStore.apenasDivergente
  }

  set apenasDivergentes(value: boolean) {
    this.getFinanceiroStore.setApenasDivergentes(value)
  }

  get alterarFuncao() {
    return this.getFinanceiroStore.alterarFuncao
  }

  set alterarFuncao(value: any) {
    this.getFinanceiroStore.setAlterarFuncao(value)
  }

  get funcoes() {
    return this.getFinanceiroStore.funcoesProfissionalExecutante
  }

  get getHistoricoSituacaoStore() {
    return getModule(HistoricoSituacaoStore, this.$store)
  }

  get loadingFuncoesProfissionalExecutante() {
    return this.getFinanceiroStore.loadingFuncoesProfissionalExecutante
  }

  async showHistory(medicoProducaoProcedimentoId: string) {
    this.loadingHistorico = medicoProducaoProcedimentoId
    await this.getHistoricoSituacaoStore.getHistoricoGeracaoItens(medicoProducaoProcedimentoId)
    this.loadingHistorico = ''
  }

  async openModalAlterarFuncao(item: any) {
    this.loadingModalAlterarFuncao = true
    await timeoutDefault()
    const medicoProducaoProcedimentoId = [item.medicoProducaoProcedimentoId]
    this.getFinanceiroStore.setItemRepasse(medicoProducaoProcedimentoId)
    this.showModalAlterarFuncao = true
    this.loadingModalAlterarFuncao = false
  }

  async openModalAlterarFuncaoEmLote(item: any) {
    this.loadingModalAlterarFuncao = true
    await timeoutDefault()
    this.getFinanceiroStore.setItemRepasse(item)
    this.showModalAlterarFuncao = true
    this.loadingModalAlterarFuncao = false
  }

  closeModalAlterarFuncao() {
    this.showModalAlterarFuncao = false
  }

  async clearAdvancedFilters() {
    const id = this.getFinanceiroStore.idForLoadItensRepasse
    this.getFinanceiroStore.clearAdvancedFilters()
    this.getFinanceiroStore.setFilterOn(false)

    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    await this.getFinanceiroStore.getGeracaoDeRepasseItensPrestador(id)
    EventBus.$emit('clearLoadingRequest')
  }

  async alterarFuncaoProfissional() {
    this.loadingAlterarFuncao = true
    const response = await this.getFinanceiroStore.alterarFuncaoGeracaoRepasse()
    if (response.success) {
      await this.filterFuncao()
      this.showModalAlterarFuncao = false
      EventBus.$emit('setSnackbar', { show: true, text: 'Função alterada com sucesso.', icon: 'check', color: '#4CAF50' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao alterar a função.', icon: 'warning', color: '#C62828' })
    }
    this.loadingAlterarFuncao = false
  }

  get drawer() {
    return this.getFinanceiroStore.filterDrawer
  }

  set drawer(value: boolean) {
    this.getFinanceiroStore.setFilterDrawer(value)
  }

  get calculoAtivo() { return this.getFinanceiroStore.calculoAtivo }

  async showAdvancedFilters() {
    this.drawer = !this.drawer
  }

  maskMoneyUtil(value) {
    return maskMoney(value)
  }

  formatDateUtil(date: string) {
    if (['', null, undefined].includes(date)) return 'Não informado'
    return moment(date).format('DD/MM/YYYY')
  }

  formatDateTimeUtil(date: string) {
    if (['', null, undefined].includes(date)) return 'Não informado'
    return moment(date).format('DD/MM/YYYY HH:mm')
  }

  formatHorasUtil(qtdeHoras: number | null) {
    return formatHoras(qtdeHoras)
  }

  async selectFuncao(item: any) {
    this.funcao = item
    await this.$nextTick(() => {
      this.filterFuncao()
    })
  }

  async filterFuncao() {
    this.getFinanceiroStore.clearPagePagination()
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    const id = this.getFinanceiroStore.idForLoadItensRepasse
    await this.getFinanceiroStore.getGeracaoDeRepasseItensPrestador(id)
    EventBus.$emit('clearLoadingRequest')
  }

  async showModalAlterarPontuacaoProfissional(item: any) {
    this.loadingAlterarPontuacaoProfissional = true
    await timeout(500)
    this.getFinanceiroStore.setProfissionalPontuacao(item.profissionalId)
    this.getFinanceiroStore.setProfissionalPontuacaoNome(item.profissionalNome)
    this.getFinanceiroStore.getProfissionalPontuacao()
    this.getFinanceiroStore.setModal({ name: 'modalAlterarPontuacaoProfissional', value: true })
    this.loadingAlterarPontuacaoProfissional = false
  }

  async showModalAlterarPrestador(item: any) {
    this.loadingAlterarPrestador = true
    await timeout(500)
    this.getFinanceiroStore.setPrestadorId(item.prestadorRecebimentoId)
    this.getFinanceiroStore.setPrestadorNome(item.prestadorNome)
    this.getFinanceiroStore.setProfissionalRepasse(item.profissionalId)
    this.getFinanceiroStore.setNomeProfissionalRepasse(item.profissionalNome)
    const medicoRecebimentoIds = [item.medicoRecebimentoId]
    this.getFinanceiroStore.setMedicoRecebimentoId(medicoRecebimentoIds)
    await this.getFinanceiroStore.getPrestadoresRepasse()
    this.getFinanceiroStore.setModal({ name: 'modalAlterarPrestador', value: true })
    this.loadingAlterarPrestador = false
  }

  async showModalAlterarPrestadorEmLote(ids: any, item: any) {
    this.loadingAlterarPrestador = true
    await timeout(500)
    this.getFinanceiroStore.setPrestadorId(item.prestadorRecebimentoId)
    this.getFinanceiroStore.setProfissionalRepasse(item.profissionalId)
    this.getFinanceiroStore.setMedicoRecebimentoId(ids)
    await this.getFinanceiroStore.getPrestadoresRepasse()
    this.getFinanceiroStore.setModal({ name: 'modalAlterarPrestador', value: true })
    this.loadingAlterarPrestador = false
  }

  async getResults(pagina: number) {
    const id = this.getFinanceiroStore.idForLoadItensRepasse
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    this.getPagina = pagina
    await this.getFinanceiroStore.getGeracaoDeRepasseItensPrestador(id)
    EventBus.$emit('clearLoadingRequest')
  }

  async queueAlterarFuncao() {
    const producaoProcedimentoIds = this.selected.map((item: any) => item.medicoProducaoProcedimentoId)
    this.openModalAlterarFuncaoEmLote(producaoProcedimentoIds)
  }

  async queueAlterarProfissional() {
    const medicoRecebimentoIds = this.selected.map((item: any) => item.medicoRecebimentoId)
    this.showModalAlterarPrestadorEmLote(medicoRecebimentoIds, this.selected[0])
  }

  async queueExcluirItens() {
    const ids = this.selected.map((item: any) => item.medicoRecebimentoId)
    this.confirmarExclusaoEmLote(ids)
  }

  async queueRecalculoRepasse() {
    // Itens de valor fixo (tipo 'repasse_fixo') tem um MedicoProducaoProcedimento sintetico
    // vinculado, entao entram no filtro de "id valido" abaixo mesmo nao sendo procedimentos reais.
    // Por isso a separacao por tipo tem que vir antes do filtro de validade, e uma selecao mista
    // precisa mandar cada grupo para o endpoint certo (nao pode ser tudo-ou-nada).
    const itensValorFixo = this.selected.filter((item: any) => item.tipo && item.tipo.key === 'repasse_fixo')

    const idsValidos = this.selected
    .filter((item: any) => !(item.tipo && item.tipo.key === 'repasse_fixo'))
    .filter((item: any) =>
      item.medicoProducaoProcedimentoId &&
      item.medicoProducaoProcedimentoId !== '00000000-0000-0000-0000-000000000000'
    )
    .map((item: any) => item.medicoProducaoProcedimentoId)

    if (itensValorFixo.length === 0 && idsValidos.length === 0) {
      this.getFinanceiroStore.setTemProcedimento(false)
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Nenhum item válido para recálculo.',
        icon: 'warning',
        color: '#FFA726'
      })
      return
    }

    this.getFinanceiroStore.setRecalculoIdsValorFixo(itensValorFixo.map((item: any) => item.medicoRecebimentoId))
    this.getFinanceiroStore.setRecalculoIds(idsValidos)
    this.getFinanceiroStore.setTemProcedimento(true)
    this.getFinanceiroStore.setModal({ name: 'recalcularRepasse', value: true })

    const totalValidos = itensValorFixo.length + idsValidos.length
    if (totalValidos < this.selected.length) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Somente os itens válidos serão considerados para recálculo.',
        icon: 'warning',
        color: '#FFA726'
      })
    }
  }

  displayColor(item: { situacaoMedicoRecebimento: { key: string, display: string } }) {
    return displayColorByStatusGeracaoRepasse(item.situacaoMedicoRecebimento.display)
  }

  showField(field: string, item: any){
    if (item.acoes) return item.acoes[field]
    return this.acoesGeracaoRepasse[field]
  }

  get actionsSelectedItens(): Record<string, boolean> {
    const fields = [
      'permiteAlterarFuncao',
      'permiteAlterarProfissional',
      'permiteExcluirItem',
      'permiteSelecionar',
      'permiteRecalcular',
    ]

    if (this.selected.length === 0) {
      return fields.reduce((acc, field) => ({ ...acc, [field]: false }), {} as Record<string, boolean>)
    }

    return fields.reduce((acc, field) => {
      const allAllow = this.selected.every((item: any) => this.showField(field, item))
      return { ...acc, [field]: allAllow }
    }, {} as Record<string, boolean>)
  }

  @Watch('apenasDivergentes')
  onChangeApenasDivergentes(value: boolean) {
    this.getFinanceiroStore.setApenasDivergentes(value)
    this.filterFuncao()
  }

  @Watch('modalItensDoRepasse')
  async onChangeModalItensDoRepasse(value: boolean) {
    if (!value) {
      this.getFinanceiroStore.clearPagePagination()
      this.getFinanceiroStore.clearFuncoes()
      this.getFinanceiroStore.clearAdvancedFilters()
      this.getFinanceiroStore.setFilterOn(false)

      this.getFinanceiroStore.setSelectedPrestador(this.selectedPrestadorFromValidacao)
      this.getFinanceiroStore.setSelectedProfissionalExecutante(this.selectedProfissionalFromValidacao)

      this.selected = []
      const id = this.getFinanceiroStore.idForLoadValidacaoEGeracaoRepasse
      await this.getFinanceiroStore.getGeracaoDeRepassesItemsVisualizar(id)
    } else {
      this.selectedPrestadorFromValidacao = this.getFinanceiroStore.selectedPrestador
      this.selectedProfissionalFromValidacao = this.getFinanceiroStore.selectedProfissionalExecutante
      await this.getFinanceiroStore.getPeriodos()
    }
  }

  @Watch('showModalAlterarFuncao')
  onChangeShowModalAlterarFuncao(value: boolean) {
    if (!value) {
      this.getFinanceiroStore.clearAlterarFuncao()
    }
  }
}
